import "../../../../content/projects/global-net/style.css";
import * as React from 'react';
export default {
  React
};